import React, { useEffect } from "react";
import useCalendarSale from "./hooks/useCalendarSale";
import "./style.scss";
import "../../../style/feature.scss";
import "../../../style/block.scss";
import "../../../style/typography.scss";
import "../../../style/calendar.scss";
import SingleAvailAbleExercise from "./single-exercise";
import { useSelector } from "react-redux";
import { State } from "../../store";
import useFacility from "../../../utils/hooks/useFacility";

const CalendarSale: React.FC = () => {
  const { getExercisesAvailable, exerciseAvailAble } = useCalendarSale();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const facilityIds = useFacility();
  useEffect(() => {
    getExercisesAvailable();
  }, [facilityIds]);

  return (
    <div>
      <div className="headline">
        {saleConfiguration.componentList && (
          <React.Fragment>
            {saleConfiguration.componentList.map((item) => (
              <React.Fragment>{item.id === "StepByStepSaleActiveV2" && <h1>{item.name}</h1>}</React.Fragment>
            ))}
          </React.Fragment>
        )}

        <div className="line"></div>

        {saleConfiguration.message_stepByStep && (
          <React.Fragment>
            {saleConfiguration.message_stepByStep.length > 12 ? (
              <div className="alert alert-comment">
                <article dangerouslySetInnerHTML={{ __html: saleConfiguration.message_stepByStep }}></article>
              </div>
            ) : (
              <React.Fragment></React.Fragment>
            )}
          </React.Fragment>
        )}
      </div>

      {exerciseAvailAble && (
        <div className="exercise-available-wrapper">
          {exerciseAvailAble.map((item, index) => (
            <React.Fragment>
              <SingleAvailAbleExercise exercise={item} key={index} />
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default CalendarSale;
